import { Component, OnInit } from '@angular/core';
import { ContactService } from '../common/services/contact.service';
import { ToastrService } from 'ngx-toastr';
import { Meta, Title } from '@angular/platform-browser';
import { SeoService } from '../common/services/seo.service';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-contact-page',
  templateUrl: './contact-page.component.html',
  styleUrls: ['./contact-page.component.scss']
})
export class ContactPageComponent implements OnInit {
  email: string;
  name: string;
  subject: string;
  message: string;
  isLoading: boolean;
  project: string;
  private queryParamsSubscription: Subscription;

  constructor(
    private contactService: ContactService,
    private toastr: ToastrService,
    private titleService: Title,
    private meta: Meta,
    private seoService: SeoService,
    private activatedRoute: ActivatedRoute
  ) {
    this.seoService.setTitle('Contact - Fun Bible');
    const initialKeywords = ['contact', 'proiect', 'email conectare', 'adresa de email', 'mesaj', 'informatii', 'nume', 'adresa email', 'subiect', 'mail'].join();
    this.meta.updateTag({property: 'keywords', content: initialKeywords});
  }

  ngOnInit(): void {
    this.queryParamsSubscription = this.activatedRoute.queryParamMap.subscribe((queryParams) => {
      this.project = queryParams.get('project');
      if (this.project) {
        this.subject = `Vreau să mă implic în proiectul „${this.project}”`;
        this.message = `Salutare,\nAș vrea să mă implic în proiectul „${this.project}”.\nContactați-mă cât mai repede!`;
      }
    });
  }

  submit() {
    this.isLoading = true;
    if (this.email && this.email.trim() !== '') {
      this.contactService.sendEmail(this.name, this.email, this.subject, this.message).subscribe(() => {
        this.isLoading = false;
        this.email = '';
        this.name = '';
        this.subject = '';
        this.message = '';
        this.toastr.success('Mesajul a fost trimis cu succes!');
      }, () => {
        this.isLoading = false;
        this.toastr.error('Mesajul nu s-a putut trimite! Încercați mai târziu!')
      });
    } else {
      this.isLoading = false;
      this.toastr.error('Completati cu un email valid!');
    }
  }

}
